import styled from '@emotion/styled';
import { Theme } from '@/styles/Theme';

const NoticeManageGuide = () => {
  return (
    <GuideContainer>
      <GuideSection>
        <GuideH3>이 페이지에서</GuideH3>
        <GuideP>랜딩, 대시보드, 앱에 표시되는 공지를 관리합니다.</GuideP>
      </GuideSection>

      <GuideSection>
        <GuideH3>필터</GuideH3>
        <GuideUl>
          <li>
            <strong>체크박스:</strong> 중요, 팝업, 랜딩 – 체크 시 해당 항목만 표시
          </li>
          <li>
            <strong>플랫폼:</strong> 전체 / 웹 / 앱 / 웹+앱
          </li>
          <li>적용, 초기화 버튼으로 필터 적용 또는 초기화</li>
        </GuideUl>
      </GuideSection>

      <GuideSection>
        <GuideH3>목록</GuideH3>
        <GuideP>
          제목(중요: 파란 점, 랜딩: 배지), 플랫폼, 중요, 팝업, 수정일, 관리(수정/삭제). 행
          클릭 시 펼쳐서 전체 내용·이미지 확인. 페이지당 5개.
        </GuideP>
      </GuideSection>

      <GuideSection>
        <GuideH3>공지 추가</GuideH3>
        <GuideP>공지 추가 클릭 → 플랫폼·제목·내용 필수, 팝업/중요/랜딩 체크, 이미지 선택.</GuideP>
      </GuideSection>

      <GuideSection>
        <GuideH3>수정·삭제</GuideH3>
        <GuideP>수정 또는 삭제 버튼 사용. 삭제 시 확인 후 처리.</GuideP>
      </GuideSection>

      <GuideSection>
        <GuideH3>랜딩 팝업</GuideH3>
        <GuideP>
          로그인 전 방문자에게 표시. 1개만 설정 가능. 폼에서 해당 체크.
        </GuideP>
      </GuideSection>

      <GuideSection>
        <GuideH3>공지 표시 위치</GuideH3>
        <GuideUl>
          <li>
            <GuideLink href="/?section=notice" target="_blank" rel="noopener noreferrer">
              랜딩 페이지 공개 목록
            </GuideLink>
            – 전체 공개
          </li>
          <li>랜딩 팝업 – 로그인 전 / 에서 (1개)</li>
          <li>대시보드 – 로그인 시 팝업 표시 체크 시</li>
          <li>모바일 앱 – 플랫폼 앱 또는 웹+앱일 때</li>
        </GuideUl>
      </GuideSection>

      <GuideSection>
        <GuideH3>참고</GuideH3>
        <GuideP>이미지 jpg/png/webp/gif. 플랫폼 웹=웹만, 앱=앱만, 웹+앱=둘 다.</GuideP>
      </GuideSection>
    </GuideContainer>
  );
};

export default NoticeManageGuide;

const GuideContainer = styled.div`
  font-size: 0.9375rem;
  line-height: 1.6;
  color: ${Theme.colors.DG_1};
`;

const GuideSection = styled.section`
  margin-bottom: 1.5rem;

  &:last-child {
    margin-bottom: 0;
  }
`;

const GuideH3 = styled.h3`
  font-size: 1rem;
  font-weight: 700;
  margin: 0 0 0.5rem;
  color: ${Theme.colors.B_1};
`;

const GuideP = styled.p`
  margin: 0 0 0.5rem;
`;

const GuideUl = styled.ul`
  margin: 0 0 0.5rem;
  padding-left: 1.25rem;
`;

const GuideLink = styled.a`
  color: ${Theme.colors.B_3};
  text-decoration: underline;

  &:hover {
    color: ${Theme.colors.B_2};
  }
`;
